import { useRef } from 'react'

import useFocusWithinDetection from '@js/common/hooks/useFocusWithinDetection'

import DesktopNavigationMenuItem from '@f-fertighaus/layout/PageHeader/partials/DesktopMenuItem'

import { MenuItemType, usePageHeader } from '../PageHeaderSSR'
import { handleMenuItemClickType } from '../PageHeaderStandard'

interface DesktopNavProps {
  onClick: handleMenuItemClickType
  currentActiveMenu: MenuItemType | null
  closeAllMenus: () => void
  postcode: string
  keepActiveMenuOpen: boolean
}

export const DesktopNav = ({
  closeAllMenus,
  onClick,
  currentActiveMenu,
  keepActiveMenuOpen,
  postcode
}: DesktopNavProps) => {
  const { menu_items: menuItems } = usePageHeader()
  const containerRef = useRef(null)

  useFocusWithinDetection({
    containerRef,
    onFocusOut: closeAllMenus
  })

  return (
    <nav className='[ f-m-l-040 ] PageHeader-navigation-row' ref={containerRef}>
      <ul className='[ f-!list ] PageHeader-nav'>
        {menuItems
          ?.filter(menuItem => !menuItem.only_mobile)
          .map(menuItem => (
            <DesktopNavigationMenuItem
              key={`desktop_menu_${menuItem.type}`}
              menuItem={menuItem}
              isOpen={currentActiveMenu === menuItem.type}
              keepOpen={keepActiveMenuOpen}
              postcode={postcode}
              onCTAMouseEnter={
                menuItem.sub_menu_items
                  ? (e: React.MouseEvent<HTMLAnchorElement>) => {
                      e.preventDefault()
                      if (currentActiveMenu === menuItem.type) {
                        return
                      }
                      onClick(menuItem.type, false)
                    }
                  : closeAllMenus
              }
              onCTAClick={
                menuItem.sub_menu_items
                  ? (e: React.MouseEvent<HTMLAnchorElement>) => {
                      e.preventDefault()
                      onClick(menuItem.type, true)
                    }
                  : closeAllMenus
              }
              currentActiveMenu={currentActiveMenu}
              closeAllMenus={closeAllMenus}
            />
          ))}
      </ul>
    </nav>
  )
}
